// for organization (b2b) functions

import * as myxhr from "./myxhr.js";

export function userSessionLogin(body) {
	return myxhr.post('/usersession/login', body);
}
